import containerFuild from '../html-snippets/container-fuild';
import buttonPrimaryHtml from '../../../views/website/products/components/description/ui-modules/button-primary/raw-html.js';
import css from '../css-snippets/section-card-slider-rivoneed.js';
const buttonRivoneedHtml = buttonPrimaryHtml({
  text: 'Built for Everyday Tasks',
  backgroundColor: '#ff0000',
  color: '#ffffff',
  radius: 8,
  iconSuffix: {
    show: true,
    src: 'https://cdn.skyfastimg.com/images/2026/06/11/image-6a2a87db55a093b7ad8c6903.png',
  },
});
const html = `
<div class="container">
  <div class="wrap-card">
    <div data-show="true" data-attribute="card-title" class="card-title">
      <h2 style="text-align: center">One Charge. One Full Day.</h2>
      <p style="text-align: center">Fast charging. Back to work in just 30 minutes.</p>
    </div>
    <div class="block-slider">
      <div class="swiper">
        <div data-attribute="list-item" class="swiper-wrapper">
          <div class="swiper-slide">
            <div data-attribute="item-slide" class="wrap-item">
              <div class="wrap-image">
                <img
                  data-attribute="image-item"
                  src="https://cdn.skyfastimg.com/images/2026/06/15/image-6a2f66e156fdb5db04a1faf9.webp"
                  alt=""
                />
              </div>
              <div data-attribute="title-item" class="wrap-content">
                <h3><span style="color: #ff0000">5200mAh</span> Battery</h3>
                <p>24h on low mode. Morning to night. No recharging needed.</p>
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div data-attribute="item-slide" class="wrap-item">
              <div class="wrap-image">
                <img
                  data-attribute="image-item"
                  src="https://cdn.skyfastimg.com/images/2026/06/15/image-6a2f66f0dd7e1628fc229054.webp"
                  alt=""
                />
              </div>
              <div data-attribute="title-item" class="wrap-content">
                <h3><span style="color: #ff0000">Type-C</span> Charging</h3>
                <p>Less time plugged in. More time getting things done.</p>
              </div>
            </div>
          </div>
          <div class="swiper-slide">
            <div data-attribute="item-slide" class="wrap-item">
              <div class="wrap-image">
                <img
                  data-attribute="image-item"
                  src="https://cdn.skyfastimg.com/images/2026/06/15/image-6a2f66fbfd3deb881ed97138.webp"
                  alt=""
                />
              </div>
              <div data-attribute="title-item" class="wrap-content">
                <h3><span style="color: #ff0000">USB</span> Output</h3>
                <p>Charge phones, radios, and other devices.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="wrap-pagination">
        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>
        <div class="swiper-pagination"></div>
      </div>
    </div>
    <div class="wrap-btn-rivoneed">${buttonRivoneedHtml}</div>
  </div>
</div>
`;
export default containerFuild(html, css, {
  backgroundColor: '#1a1a1a',
  textColor: '#ffffff',
  backgroundImage: 'https://cdn.skyfastimg.com/images/2026/06/13/image-6a2d116dde8c6f928b83d50c.webp',
});
